import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formValueSelector } from 'redux-form';
import Form from '../../components/forms/LegitimateForm';
import { saveLegitimate, withRedirect } from '../../CroActions';
import { breadcrumbs } from '../../../../actions/appActions';

const selector = formValueSelector('legitimateForm');

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: 'Oprávněné orgány' }, { label: 'Nový oprávněný orgán' }],
  loginData: { name: selector(state, 'name') },
  isNew: true
});

const onSubmit = (url) => withRedirect(saveLegitimate(url), `${url}/opravnene-organy`);

const mapDispatchToProps = (dispatch, { auth }) => ({
  ...bindActionCreators({ onSubmit: onSubmit(auth.startUrl), breadcrumbs }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
